import React from "react";
import { Box, Typography } from "@mui/joy";

interface CompanyHeaderProps {
  companyName: string;
  companyAddress: string;
}

const CompanyHeader: React.FC<CompanyHeaderProps> = ({ companyName, companyAddress }) => {
  return (
    <Box 
      sx={{ 
        py: 2, 
        mb: 2, 
        mx: { xs: "auto", md: 0 },
        maxWidth: { xs: "600px", md: "none" },
      }}>
      <Typography
        level="h1"
        sx={{
          fontSize: { xs: "2rem", md: "2.5rem" },
          fontWeight: 700,
          mb: 1,
          color: "#1A1B1D",
        }}
      >
        {companyName}
      </Typography>
      <Typography
        level="body-lg"
        sx={{
          fontSize: { xs: "1rem", md: "1.125rem" },
          color: "#7B7F85",
        }}
      >
        {companyAddress}
      </Typography>
    </Box>
  );
};

export default CompanyHeader; 